/**
 * Remembers that a person has been told about connecting an AI assistant.
 *
 * Keyed by user id, unlike the demo-mode keys: on a shared browser a bare key
 * would let one person's "Not now" silence the announcement for everyone else.
 *
 * This is per device. The cross-device case that matters — the person already
 * connected an assistant — is answered by the server, not by this flag.
 */
const storageKey = (userId: string | number) =>
  `hasSeenMcpAnnouncement:${userId}`;

export const mcpAnnouncementStorage = {
  hasSeen: (userId: string | number): boolean => {
    try {
      return localStorage.getItem(storageKey(userId)) === 'true';
    } catch {
      // Storage is blocked. Treat as seen: never announcing beats announcing
      // on every page load with no way to make it stop.
      return true;
    }
  },

  markSeen: (userId: string | number): void => {
    try {
      localStorage.setItem(storageKey(userId), 'true');
    } catch {
      // Nothing to do; hasSeen already answers true when storage is blocked.
    }
  },
};
